import { Link } from 'react-router-dom';
import './Legal.css';

function PrivacyClient() {
  return (
    <div className="legal-page">
      <header className="legal-header">
        <div className="legal-header-content">
          <Link to="/" className="back-button">
            <span className="back-arrow">←</span>
            Retour
          </Link>
        </div>
      </header>

      <main className="legal-content">
        <h1 className="legal-title">Politique de Confidentialité</h1>
        <p className="legal-update">Dernière mise à jour : Décembre 2024</p>

        <div className="legal-tabs">
          <Link to="/privacy" className="legal-tab active">Clients</Link>
          <Link to="/privacy-pro" className="legal-tab">Chauffeurs Pro</Link>
        </div>

        <p className="legal-intro">
          Chez RideLuv, la protection de vos données personnelles est une priorité absolue. Cette politique explique quelles données nous collectons, pourquoi et comment nous les utilisons, conformément au Règlement Général sur la Protection des Données (RGPD).
        </p>

        <section className="legal-section">
          <h2 className="legal-section-title">1. Responsable du traitement</h2>
          <p className="legal-section-text">
            RideLuv SAS, société par actions simplifiée, est responsable du traitement de vos données personnelles. Pour toute question relative à vos données, vous pouvez nous contacter à privacy@rideluv.com ou par courrier à notre siège social.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="legal-section-title">2. Données collectées</h2>
          <p className="legal-section-text">
            Nous collectons : vos données d'identification (nom, prénom, email, numéro de téléphone), vos données de paiement (traitées de manière sécurisée par nos prestataires certifiés PCI-DSS), vos données de géolocalisation (uniquement pendant l'utilisation de l'Application), votre historique de courses, vos préférences et paramètres, ainsi que les données techniques (type d'appareil, système d'exploitation, identifiants uniques).
          </p>
        </section>

        <section className="legal-section">
          <h2 className="legal-section-title">3. Finalités du traitement</h2>
          <p className="legal-section-text">
            Vos données sont utilisées pour : fournir et améliorer nos services de mise en relation, traiter vos paiements de manière sécurisée, vous envoyer des informations sur vos courses (confirmations, factures), assurer la sécurité de la plateforme et prévenir la fraude, respecter nos obligations légales, et avec votre consentement, vous envoyer des offres personnalisées.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="legal-section-title">4. Base légale</h2>
          <p className="legal-section-text">
            Le traitement de vos données repose sur : l'exécution du contrat (fourniture du service), notre intérêt légitime (amélioration du service, sécurité), le respect d'obligations légales (conservation des factures), et votre consentement (communications marketing). Vous pouvez retirer votre consentement à tout moment.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="legal-section-title">5. Partage des données</h2>
          <p className="legal-section-text">
            Vos données peuvent être partagées avec : les chauffeurs partenaires (informations nécessaires à la course), nos prestataires techniques (hébergement, paiement, analytics), les autorités compétentes sur demande légale. Nous ne vendons jamais vos données personnelles à des tiers. Nos partenaires sont contractuellement tenus de respecter la confidentialité de vos données.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="legal-section-title">6. Transferts internationaux</h2>
          <p className="legal-section-text">
            Vos données sont principalement hébergées dans l'Union Européenne. En cas de transfert hors UE, nous nous assurons que des garanties appropriées sont en place (clauses contractuelles types, décision d'adéquation) conformément aux exigences du RGPD.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="legal-section-title">7. Conservation des données</h2>
          <p className="legal-section-text">
            Vos données sont conservées pendant la durée de votre utilisation du service, puis : 3 ans après votre dernière activité pour les données de compte, 10 ans pour les données de facturation (obligation légale), 1 an pour les données de géolocalisation. À l'issue de ces délais, vos données sont supprimées ou anonymisées.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="legal-section-title">8. Sécurité</h2>
          <p className="legal-section-text">
            Nous mettons en œuvre des mesures techniques et organisationnelles robustes : chiffrement des données en transit (TLS) et au repos, authentification sécurisée, accès restreint aux données sur le principe du besoin d'en connaître, audits de sécurité réguliers, formation de nos équipes. En cas de violation de données, nous vous informerons dans les meilleurs délais.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="legal-section-title">9. Vos droits</h2>
          <p className="legal-section-text">
            Conformément au RGPD, vous disposez des droits suivants : accès à vos données, rectification des données inexactes, effacement (« droit à l'oubli »), limitation du traitement, portabilité de vos données, opposition au traitement, retrait du consentement. Pour exercer ces droits, contactez-nous à privacy@rideluv.com. Vous pouvez également introduire une réclamation auprès de la CNIL.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="legal-section-title">10. Cookies et traceurs</h2>
          <p className="legal-section-text">
            L'Application utilise des technologies de suivi pour améliorer votre expérience et analyser l'utilisation du service. Vous pouvez gérer vos préférences dans les paramètres de l'Application. Les cookies essentiels au fonctionnement ne peuvent être désactivés.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="legal-section-title">11. Mineurs</h2>
          <p className="legal-section-text">
            L'Application n'est pas destinée aux personnes de moins de 18 ans. Nous ne collectons pas sciemment de données concernant des mineurs. Si vous êtes parent et pensez que votre enfant nous a fourni des données, contactez-nous pour leur suppression.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="legal-section-title">12. Modifications</h2>
          <p className="legal-section-text">
            Cette politique peut être mise à jour pour refléter les évolutions de nos pratiques ou de la réglementation. Nous vous informerons de tout changement significatif. La date de dernière mise à jour est indiquée en haut de ce document.
          </p>
        </section>
      </main>

      <footer className="legal-footer">
        <p className="legal-footer-text">
          Une question sur vos données ? Contactez-nous à <a href="mailto:privacy@rideluv.com" className="legal-footer-link">privacy@rideluv.com</a>
        </p>
      </footer>
    </div>
  );
}

export default PrivacyClient;
